import { ExploreBlock, JourneyBlockContent } from '@addmile/backend-client';

// The journey only stores the slug; the rest is what the editor shows until the next load.
export const toBlockContent = (block: ExploreBlock): JourneyBlockContent => ({
  slug: block.slug,
  type: block.type,
  title: block.title,
  imageUrl: block.imageUrl,
  duration: block.details?.duration,
});
